import { render, staticRenderFns } from "./RecruitmentDetails.vue?vue&type=template&id=21711b30&scoped=true"
import script from "./RecruitmentDetails.vue?vue&type=script&lang=js"
export * from "./RecruitmentDetails.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentDetails.vue?vue&type=style&index=0&id=21711b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21711b30",
  null
  
)

export default component.exports